import React, { useState } from "react";
import GuestMails from "@/components/mailbox/GuestMails";
import { X, Check, Mail } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { FLAGS } from "@/lib/constants";
import { useLang } from "@/i18n";

const Row = ({ label, value, testid }) => (
  <div className="flex items-start justify-between gap-4 border-b border-border/60 py-1.5 last:border-0">
    <span className="text-[11px] font-semibold uppercase tracking-wider text-muted-foreground">{label}</span>
    <span className="text-right text-sm font-medium break-all" data-testid={testid}>{value || "—"}</span>
  </div>
);

export default function GuestInfoDialog({ guest, onClose }) {
  const { t } = useLang();
  const navigate = useNavigate();
  const [tab, setTab] = useState("info");
  if (!guest) return null;
  const tabBtn = (key, label, testid) => (
    <button type="button" onClick={() => setTab(key)} data-testid={testid}
      className={`rounded-full px-3 py-1 text-xs font-semibold transition-colors ${tab === key ? "bg-primary text-primary-foreground" : "bg-secondary text-muted-foreground hover:text-foreground"}`}>{label}</button>
  );
  return (
    <Dialog open onOpenChange={(o) => !o && onClose()}>
      <DialogContent className={`${tab === "mails" ? "sm:max-w-lg" : "sm:max-w-sm"} bg-background`} data-testid="guest-info-dialog">
        <DialogHeader>
          <DialogTitle className="font-display flex items-center gap-2">
            {guest.first_name} {guest.last_name}
            {guest.rood_lintje && <Check className="h-4 w-4 text-rose-600" strokeWidth={3} title={FLAGS.rood_lintje.nl} />}
          </DialogTitle>
        </DialogHeader>
        <div className="flex gap-1.5">{tabBtn("info", t("guest_data"), "guest-tab-info")}{tabBtn("mails", t("mb_emails"), "guest-tab-mails")}</div>
        {tab === "mails" ? <GuestMails email={guest.email} onNavigate={onClose} /> : (
        <div className="space-y-0">
          <Row label={t("email")} value={guest.email} testid="ginfo-email" />
          <Row label={t("phone")} value={guest.phone} testid="ginfo-phone" />
          <Row label={t("language")} value={(guest.language || "").toUpperCase()} testid="ginfo-language" />
          <Row label={t("country")} value={guest.country} testid="ginfo-country" />
          <Row label={t("license_plate")} value={guest.license_plate} testid="ginfo-plate" />
          <Row label={t("notes")} value={guest.notes} testid="ginfo-notes" />
        </div>)}
        {guest.email && (
          <button type="button" onClick={() => { onClose(); navigate(`/mailbox?q=${encodeURIComponent(guest.email)}`); }} data-testid="guest-info-mails"
            className="mt-2 inline-flex items-center justify-center gap-1.5 rounded-lg border border-border px-3 py-2 text-sm font-semibold hover:bg-secondary transition-colors">
            <Mail className="h-4 w-4" />{t("mb_emails_of_guest")}
          </button>
        )}
        <button type="button" onClick={onClose} data-testid="guest-info-close"
          className="mt-2 inline-flex items-center justify-center gap-1.5 rounded-lg border border-border px-3 py-2 text-sm font-semibold hover:bg-secondary transition-colors">
          <X className="h-4 w-4" />{t("close")}
        </button>
      </DialogContent>
    </Dialog>
  );
}
